<script setup lang="ts">
import { computed } from "vue";
import type { UserNotification } from "@/types";

const props = defineProps<{
    notification: UserNotification;
}>();

const emit = defineEmits<{
    (e: "select", notification: UserNotification): void;
}>();

const isUnread = computed(() => props.notification.read_at === null);
const createdAtText = computed(() => {
    const date = new Date(props.notification.created_at);
    return Number.isNaN(date.getTime()) ? "" : date.toLocaleString();
});

const handleSelect = (): void => {
    emit("select", props.notification);
};
</script>

<template>
    <button
        type="button"
        class="w-full text-left rounded-lg border px-3 py-4 transition-colors"
        :class="
            isUnread
                ? 'border-gold-400/50 bg-gold-400/5 hover:bg-gold-400/10'
                : 'border-noir-700 bg-noir-900/40 hover:bg-noir-800/50'
        "
        @click="handleSelect"
    >
        <div class="flex items-start justify-between gap-3">
            <div class="min-w-0">
                <p class="text-sm font-semibold text-cream-100 truncate">
                    {{ notification.title }}
                </p>
                <p class="mt-1 text-xs text-noir-300 line-clamp-2">
                    {{ notification.message }}
                </p>
            </div>
            <span
                v-if="isUnread"
                class="mt-1 inline-block h-2 w-2 rounded-full bg-gold-400"
            ></span>
        </div>

        <div class="mt-2 flex items-center justify-between">
            <p class="text-[11px] text-noir-400">{{ createdAtText }}</p>
            <p v-if="notification.link" class="text-[11px] text-gold-400">→</p>
        </div>
    </button>
</template>
